import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EventEmitter from 'src/utils/EventEmitter';
import useStateRef from "react-usestateref";
import { useSnackbar } from 'notistack';
import './navbar.css';

const NavBarBottom = (props) => {
  /* eslint-disable */
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [image, setImage] = useState('');
  const [isVerified, setIsVerified, isVerifiedRef] = useStateRef(null);
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps */

  const clickMenu = (url) => {
    navigate(url);
      EventEmitter.emit("show_full", { value: false });
  }

  useEffect(() => {
    const location = window.location.pathname;
    if (location === "/" || location === "/scripts") {
      setTitle("Scripts")
      setImage("myscripts_logo.svg")
    } else if (location === "/orders") {
      setTitle("Orders")
      setImage("myorders_logo.svg")
    } else if (location === "/profile") {
      setTitle("Profile")
      setImage("myprofile_logo.svg")
    } else if (location === "/doctor" || location === "/appointment/form" || location === "/appointment/list") {
      setTitle("Doctor")
      setImage("mydoctor_logo.svg")
    } else {
      setTitle("")
      setImage("")
    }
  }, [window.location.pathname]);
  /* eslint-enable react-hooks/exhaustive-deps */

  const getUserProfile = () => {
    // var value = "";
    // Adding condition check to bypass early integration issues
    var user_data = localStorage.user_data? JSON.parse(localStorage.user_data) : '';

    var isVerifiedUser = false;
    if (user_data) {
      if (user_data.CustomFields) {
        if (user_data.CustomFields.AccessUser_Profile_Image) {
          if (user_data.CustomFields.AccessUser_Profile_Image.Value) {
            // value += user_data.CustomFields.AccessUser_Profile_Image.Value;
          }
        }

        if (user_data.CustomFields.AccessUser_Identity_Verified) {
          if (user_data.CustomFields.AccessUser_Identity_Verified.Value === true || user_data.CustomFields.AccessUser_Identity_Verified.Value === "true") {
            isVerifiedUser = true;
          }
        }
      }
    }

    setIsVerified(isVerifiedUser)
  }

  return (
    <>
      <div className="navbar-content-mobile">
        <div className="navbar-item-wrapper">
          <div className={`navbar-item dashboard ${window.location.pathname === "/" || window.location.pathname === "/movements" ? 'navbar-item-selected' : ''}`} onClick={() => clickMenu('/movements')}>
            <div className="navbar-item-image">
              <div className={`navbar-image navbar_image-dashboard ${window.location.pathname === "/" || window.location.pathname === "/movements" ? "selected" : ""}`} alt="Movements_tab" />
            </div>
          </div>
          <div className={`navbar-item catalogue ${window.location.pathname === "/sales" ? 'navbar-item-selected' : ''}`} onClick={() => clickMenu('/sales')}>
            <div className="navbar-item-image">
              <div className={`navbar-image navbar_image-catalogue ${window.location.pathname === "/sales" ? "selected" : ""}`} alt="Sales_tab" />
            </div>
          </div>
          {/* <div className={`navbar-item orders ${window.location.pathname === "/orders" ? 'navbar-item-selected' : ''}`} onClick={() => clickMenu('/orders')}>
            <div className="navbar-item-image">
              <div className={`navbar-image navbar_image-orders ${window.location.pathname === "/orders" ? "selected" : ""}`} alt="Orders_tab" />
            </div>
          </div>
          <div className={`navbar-item accounts ${window.location.pathname === "/accounts" ? 'navbar-item-selected' : ''}`} onClick={() => clickMenu('/accounts')}>
            <div className="navbar-item-image">
              <div className={`navbar-image navbar_image-accounts  ${window.location.pathname === "/accounts" ? "selected" : ""}`} alt="Accounts_tab" />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default NavBarBottom;
